// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Keskustelu',
  working: 'Työstän asiaa…',
  stopped: 'Pysäytetty. Mikään ei muuttunut.',
  step_stopped: 'Pysäytetty',
  not_sent: 'Ei lähetetty',
  failed: {
    text: 'Jokin meni pieleen meidän päässämme, joten mikään ei muuttunut. Yritä hetken kuluttua uudelleen.',
    retry: 'Yritä uudelleen',
  },
  question: {
    type_answer: 'Tai kirjoita vastauksesi alle.',
  },
  unavailable: {
    title: {
      amigo: 'Amigo ei ole juuri nyt käytettävissä.',
      assistant: 'Avustaja ei ole juuri nyt käytettävissä.',
    },
    text: 'Mikään ei ole muuttunut, ja muu hallintapaneeli toimii normaalisti. Yritä muutaman minuutin kuluttua uudelleen.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Tänään',
  when: {
    today: 'Tänään, {{time}}',
    yesterday: 'Eilen, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Uusi keskustelu: {{restaurant}}. Kohteen {{previous}} keskustelut löytyvät Keskustelut-kohdasta, kun palaat siihen.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: '{{name}}in chat (FoodAmigos)',
      owner: '{{name}}in chat (omistaja)',
      staff: '{{name}}in chat (henkilökunta)',
      partner: '{{name}}in chat (kumppani)',
      other: '{{name}}in chat',
      unnamed: 'Jonkun toisen chat',
    },
    text: 'Käyttäjän {{name}} keskustelu. Voit lukea sen, mutta et vastata tai hyväksyä sen kortteja.',
    text_unnamed: 'Jonkun toisen chat. Voit lukea sen, mutta et vastata tai hyväksyä sen kortteja.',
    new_chat: 'Uusi keskustelu',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Tämä keskustelu on päättynyt. Aloita uusi keskustelu jatkaaksesi.',
    new_chat: 'Uusi keskustelu',
    moved_line: 'Uusi keskustelu, koska edellinen oli päättynyt',
  },
  composer: {
    label: 'Viesti',
    placeholder: 'Esitä kysymys tai kuvaile muutos',
    placeholder_answer: 'Kirjoita vastauksesi',
    hint: 'Enter lähettää · Vaihto+Enter uusi rivi',
  },
  table: {
    show_all: 'Näytä kaikki {{count}} riviä',
    show_fewer: 'Näytä vähemmän',
  },
  steps: {
    areas: 'Tarkistan, missä voin auttaa',
    area_describe: 'Tarkastelen kohdetta {{area}}',
    read: 'Luen tietojasi',
    propose: 'Valmistelen muutosta',
    change_set_get: 'Tarkistan muutoksen',
    gap_record: 'Kirjaan tämän tiimillemme',
    research: 'Selvitän, miten tämä toimii',
    screen_find: 'Etsin oikeaa sivua',
    file_read: 'Luen tiedostoasi',
    shop_check: 'Tarkistan kauppasi tiedot',
    area_describe_other: 'Tarkastellaan tätä aluetta',
    other: 'Tarkistetaan jotain',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Menüä ei voitu lukea',
      hours: 'Aukioloaikoja ei voitu lukea',
      order_settings: 'Tilausasetuksia ei voitu lukea',
      my_info: 'Tietojasi ei voitu lukea',
      marketing: 'Markkinointiasi ei voitu lukea',
      gift_cards: 'Lahjakortteja ei voitu lukea',
      reports: 'Lukujasi ei voitu lukea',
      other: 'Tietojasi ei voitu lukea',
    },
    propose: {
      menu: 'Menumuutosta ei voitu valmistella',
      hours: 'Aukioloaikojen muutosta ei voitu valmistella',
      order_settings: 'Tilausasetusten muutosta ei voitu valmistella',
      my_info: 'Tietojesi muutosta ei voitu valmistella',
      marketing: 'Markkinointimuutosta ei voitu valmistella',
      gift_cards: 'Lahjakorttimuutosta ei voitu valmistella',
      other: 'Muutosta ei voitu valmistella',
    },
    change_set_get: { other: 'Muutosta ei voitu tarkistaa' },
    research: { other: 'Toimintaa ei voitu selvittää' },
    screen_find: { other: 'Sivua ei löytynyt' },
    file_read: { other: 'Tiedostoasi ei voitu lukea' },
    shop_check: { other: 'Kauppaasi ei voitu avata' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'ruokalista',
    hours: 'aukioloajat',
    order_settings: 'tilausasetukset',
    my_info: 'ravintolasi tiedot',
    marketing: 'markkinointi',
    reports: 'raportit',
  },
};
